import { getApiBaseUrl } from '../utils/apiBaseUrl';

function apiUrl(path) {
  const base = getApiBaseUrl();
  return base ? `${base}${path}` : path;
}

function getToken() {
  try {
    return window.localStorage.getItem('jassp-auth-token') || '';
  } catch {
    return '';
  }
}

function headers() {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${getToken()}`,
  };
}

async function readJson(res) {
  return res.json().catch(() => ({}));
}

async function throwIfError(res) {
  const data = await readJson(res);
  if (!res.ok || !data.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : `HTTP ${res.status}`);
  }
  return data;
}

export async function fetchSettings() {
  const res = await fetch(apiUrl('/api/admin/settings'), {
    headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
  });
  return throwIfError(res);
}

export async function updateSettings(settingsMap) {
  const res = await fetch(apiUrl('/api/admin/settings'), {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(settingsMap),
  });
  return throwIfError(res);
}

export async function fetchPublicSettings() {
  const res = await fetch(apiUrl('/api/admin/settings/public'), {
    headers: { Accept: 'application/json' },
  });
  return throwIfError(res);
}
